const STEPS = ['Pay Employees', 'Readiness Check', 'Review Payslip', 'Approved'] as const;

export type StepLabels = readonly [string, string, string, string];

/** The four-stage progress bar. Completed steps are marked and named, so state never relies on colour alone. */
export function Stepper({ current, labels = STEPS, ariaLabel = 'Pay Employees progress' }: { current: 1 | 2 | 3 | 4; labels?: StepLabels; ariaLabel?: string }) {
  return (
    <ol className="wc-stepper" aria-label={ariaLabel}>
      {labels.map((label, i) => {
        const n = i + 1;
        const state = n < current ? 'done' : n === current ? 'current' : 'todo';
        return (
          <li key={label} className={`wc-stepper__step wc-stepper__step--${state}`} aria-current={state === 'current' ? 'step' : undefined}>
            <span className="wc-stepper__dot" aria-hidden="true">{state === 'done' ? '✓' : n}</span>
            <span className="wc-stepper__label">
              {label}
              <span className="sr-only">{state === 'done' ? ' (completed)' : state === 'todo' ? ' (not started)' : ' (current step)'}</span>
            </span>
          </li>
        );
      })}
    </ol>
  );
}
